<template>
    <span class="close" @click="close"></span>
</template>

<script>
    import './close.scss'
    import close from './close.js'
    export default close
</script>


// WEBPACK FOOTER //
// close.vue?0a5a984b